import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';

export interface I2gButtonTab {
  label: string;
  value: any;
  trackingObject: ITrackingObject;
  trackingAction: ITrackingAction;
}

@Component({
  selector: 'i2g-button-tabs',
  templateUrl: './button-tabs.component.html',
  styleUrls: ['./button-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonTabsComponent {
  @Input() tabs: List<I2gButtonTab>;
  @Input() selectedTabIndex = 0;

  @Output() tabSelected = new EventEmitter<I2gButtonTab>();

  constructor() {}

  onTabSelected(tab: I2gButtonTab, index: number) {
    this.selectedTabIndex = index;
    this.tabSelected.emit(tab);
  }
}
